<template lang='pug'>
  v-flex(:class="classObj", :title='component.label' style="position: relative")
    v-tooltip(bottom, :disabled="!component.definition")
      template(v-slot:activator="{ on, attrs }")
        div(v-bind="attrs", v-on="on") 
          v-text-field.ma-0.pa-0(
            v-model='data'
            :type='component.inputType || "text"'
            :placeholder='component.placeholder'
            :required='component.required'
            :disabled='component.disabled'
            :readonly='component.readonly'
            :label='label' :suffix='component.suffix'
            :prefix='component.prefix || " "'
            :min='component.min'
            :max='component.max'
            :step='component.step'
            :mask='component.mask'
            v-money='component.maskOptions'
            ref="textfield"
            hide-details
            @change="onChange")
      span {{ component.definition }}
    field-info(:field="id" :component="component" :resultForm="resultForm")
</template>

<script>
import FieldInfo from '../buttons/FieldInfo'

export default {
  name: 'u-text-field',

  props: {
    id: {
      type: String
    },
    component: {
      type: Object,
      required: true
    },
    resultForm: {
      type: Object
    },
    value: {}
  },

  components: {
    FieldInfo
  },

  watch: {
    value: {
      handler: function (val) {
        let newVal = 0
        if (val && typeof val === 'object') {
          newVal = val.result
        } else {
          newVal = val
        }

        if (this.component.maskOptions) {
          const elTextfieldInput = this.$refs.textfield.$el.getElementsByTagName('input')[0]
          elTextfieldInput.value = newVal
          elTextfieldInput.dispatchEvent(new Event('input'))
        } else this.data = newVal
      },
      deep: true
    },
    data (val) {
      if (this.component.filter) {
        this.data = this.dynamicFilter(this.component.filter, val)
      }
    }
  },

  computed: {
    label () {
      return this.t(this.id + '.label', this.component.label)
    }
  },

  data () {
    return {
      data: null
    }
  },

  methods: {
    dynamicFilter: function (filter, value) {
      return this.$filters[filter](value)
    }
  }
}
</script>

<style lang='stylus' scoped>
</style>



// WEBPACK FOOTER //
// src/components/form/inputs/TextField.vue